import React from 'react'
import {
  useColorModeValue,
  Image,
  useMediaQuery,
  Box,
  Stack,
  StackDivider,
  Container
} from '@chakra-ui/react'
import { useLogoColor } from 'hooks'

import styled from '@emotion/styled'
import { Copyright } from 'components'
import { theme } from 'theme'

import { SubscribeForm } from 'components/SubscribForm'
import { LinkGrid } from './LinkGrid'
import SocialMediaLinks from './SocialMediaLinks'

type FooterProps = {}

const FooterWrapper = styled(Box)`
  &::after {
    content: '';
    z-index: -1;
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 100vw;
    height: 100vh;
    transform: translate(-50%);
    clip-path: polygon(0 10rem, 100% 0, 100% 100%, 0% 100%);
  }
  &::before {
    content: '';
    z-index: -3;
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 100vw;
    height: 90%;
    transform: translate(-50%, 0);
    clip-path: polygon(31% 0, 100% 41%, 100% 100%, 0 78%);
  }
  @media (max-width: 40em) {
    &::after {
      border-radius: 0;
    }
  }
`

const Footer: React.FC<FooterProps> = ({}) => {
  const afterBg = useColorModeValue(theme.colors.gray[100], theme.colors.gray[700])
  const logo = useLogoColor()
  const beforeBg = useColorModeValue('#52525211', '#4a55682b')
  const [isTabletOrMobile] = useMediaQuery('(max-width: 40em)')
  return (
    <FooterWrapper
      _after={{
        bg: `linear-gradient(to top,${afterBg}, transparent)`
      }}
      _before={{
        display: isTabletOrMobile ? 'none' : undefined,
        bg: `linear-gradient(to top left, ${beforeBg}, transparent)`
      }}
      mt={16}
      py={20}
      as="footer"
      role="contentinfo"
      mx="auto"
      maxW="7xl"
    >
      <Container maxW="container.xl">
        <Stack spacing="10" divider={<StackDivider />}>
          <Stack direction={{ base: 'column', lg: 'row' }} spacing={{ base: '10', lg: '28' }}>
            <Box flex="1">
              <Image src={logo} alt="nsoko property logo" minW={100} maxW={110} />
            </Box>
            <Stack direction={{ base: 'column', md: 'row' }} spacing={{ base: '10', md: '20' }}>
              <LinkGrid spacing={{ base: '10', md: '20', lg: '28' }} flex="1" />
              <SubscribeForm width={{ base: 'full', md: 'sm' }} />
            </Stack>
          </Stack>
          <Stack direction={{ base: 'column-reverse', md: 'row' }} justifyContent="space-between">
            <Copyright />
            <SocialMediaLinks />
          </Stack>
        </Stack>
      </Container>
    </FooterWrapper>
  )
}

export default Footer
